import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRoute } from '../../util/withRoute';

class NormalLink extends Component {
  constructor(props) {
    super(props);
    this.state = { isHover: false };
  }

  getSideBarActiveStatus = (link, activeLink) => {
    return link === activeLink;
  };

  render() {
    const { url, name, icon, isUrlArray, isShowSideBar, pathName, toggleSideBar, hideSidebar } = this.props;
    const isActive = this.getSideBarActiveStatus(isUrlArray ? url[0] : url, pathName);

    return (
      <Link
        to={isUrlArray ? url[0] : url}
        className={`vm-nav-item ${isActive ? 'active' : ''}`}
        onMouseEnter={() => this.setState({ isHover: true })}
        onMouseLeave={() => this.setState({ isHover: false })}
        title={!isShowSideBar ? name : ''}
        onClick={() => {
          if (window.innerWidth < 800) {
            if (toggleSideBar) {
              toggleSideBar();
            }
            if (hideSidebar) {
              hideSidebar();
            }
          }
        }}
      >
        <i className={`${icon} vm-icon`} aria-hidden="true" />
        {isShowSideBar && <span>{name}</span>}
      </Link>
    );
  }
}

export default withRoute(NormalLink);